// extracted by mini-css-extract-plugin
module.exports = {"header":"a2c79c7e7d--header--BwL0l","panel":"a2c79c7e7d--panel--bswEe","title":"a2c79c7e7d--title--YIWsS","close":"a2c79c7e7d--close--PHb9e"};